const FacebookProjectionType =
{
	EQUIRECTANGULAR:'EQUIRECTANGULAR',
	CUBEMAP:'CUBEMAP',
	SINGLE_FISH_EYE:'SINGLE_FISH_EYE'
}
export default FacebookProjectionType;
